import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { IMAGES } from "@/data/content";

export default function AboutPreview() {
  return (
    <section data-testid="about-preview" className="py-20 sm:py-28 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-4 rounded-[2.5rem] bg-gradient-to-br from-gold/25 via-transparent to-brand/20 blur-xl pointer-events-none" />
              <div className="relative rounded-[2rem] overflow-hidden aspect-[4/5] max-w-md shadow-lift ring-1 ring-ink/5">
                <img
                  src={IMAGES.principal}
                  alt="Anu Prakash, Principal of Invesmo"
                  className="w-full h-full object-cover"
                  data-testid="about-preview-image"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian/45 via-transparent to-transparent" />
                <div className="absolute bottom-6 left-6 right-6 text-white">
                  <div className="font-display text-xl font-bold">Anu Prakash</div>
                  <div className="text-xs tracking-[0.2em] uppercase text-gold mt-1">Principal · Invesmo</div>
                </div>
              </div>
            </div>
          </Reveal>

          <div>
            <Reveal>
              <Eyebrow>The principal</Eyebrow>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-ink leading-[1.1] mb-8">
                Senior credit judgment, <span className="font-editorial italic font-medium text-gold-600">personally applied.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="text-ink/60 leading-relaxed mb-6">
                Anu's career spans senior roles across banking, institutional credit and property finance — plus
                decades spent running businesses, developing property and pursuing international trading opportunities.
                That lived commercial experience is now applied to every client he advises.
              </p>
              <p className="font-editorial italic text-xl text-ink/75 leading-relaxed border-l-2 border-gold pl-6 mb-10">
                "Good broking isn't finding a loan. It's structuring capital so the next decision is easier than the last."
              </p>
              <Link
                to="/about"
                data-testid="about-preview-cta"
                className="group inline-flex items-center gap-3 rounded-full border border-ink/15 px-7 py-3.5 text-sm font-semibold text-ink transition-all duration-300 hover:border-gold hover:text-gold-700"
              >
                Read Anu's story
                <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
